// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-template-list {
	list-style-type: none;
	margin: 0;
	padding: 0;
	column-count: 5;
	column-gap: 1rem;
}

.message-template-list li {
	cursor: pointer;
	padding: 0.425rem;
	display: inline-block;
	width: 100%;
}

.message-template-list li:hover {
	background: border-box rgba(236, 236, 236, 0.6);
	border-radius: 4px;
	/*font-weight: 600;*/
}

@media (max-width: 750px) {
	.message-template-list {
		column-count: 3;
	}
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/message-template.css"],"names":[],"mappings":"AAAA;CACC,qBAAqB;CACrB,SAAS;CACT,UAAU;CACV,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,qBAAqB;CACrB,WAAW;AACZ;;AAEA;CACC,+CAA+C;CAC/C,kBAAkB;CAClB,oBAAoB;AACrB;;AAEA;CACC;EACC,eAAe;CAChB;AACD","sourcesContent":[".message-template-list {\n\tlist-style-type: none;\n\tmargin: 0;\n\tpadding: 0;\n\tcolumn-count: 5;\n\tcolumn-gap: 1rem;\n}\n\n.message-template-list li {\n\tcursor: pointer;\n\tpadding: 0.425rem;\n\tdisplay: inline-block;\n\twidth: 100%;\n}\n\n.message-template-list li:hover {\n\tbackground: border-box rgba(236, 236, 236, 0.6);\n\tborder-radius: 4px;\n\t/*font-weight: 600;*/\n}\n\n@media (max-width: 750px) {\n\t.message-template-list {\n\t\tcolumn-count: 3;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
